/** 書きかけのメンション。`at` は `@` の位置、`query` は `@` の後ろに打たれた絞り込み語。 */
export type PendingMention = { at: number; query: string };

/**
 * キャレットの直前で `@…` を書きかけているかを見る。
 *
 * 空白や改行、括弧をまたいだ `@` は候補を出さない。文中の `@` を誤って拾わないためで、
 * すでに表記になっている `@[名前](参照)` の中でも出さない（`@` の次が `[` になる）。
 *
 * **基準はキャレットである。** 以前は本文の最後の `@` を見ていたため、文の先頭や途中に `@` を
 * 打つと「`@` から本文の終わりまで」がまるごと絞り込み語になり、候補が 1 件も一致しなかった
 * （記録 23）。日本語の本文は空白を入れないので、末尾以外では必ずこうなる。すでにメンションが
 * ある本文でも、最後の `@` がメンションの `@` になって候補が出なかった。対象を選ぶ別の入力欄が
 * 無いので、**後から対象を 1 つ足す操作が素直にできない**という形で効いていた。
 *
 * `@` の位置を返すのは、挿し込みが「`@` からキャレットまで」を置き換えるためである
 * （{@link insertMention}）。同じ探索を二度書かないよう、位置と語を一緒に返す。
 */
export function pendingMention(text: string, caret?: number): PendingMention | null {
    const end = caret ?? text.length;
    const at = text.lastIndexOf("@", Math.max(0, end - 1));
    if (at < 0 || at >= end) return null;
    const query = text.slice(at + 1, end);
    if (/[\s[\]()]/.test(query)) return null;
    return { at, query };
}
